








































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator'
import { FindTituloUseCase, SaveTituloUseCase } from '@/usecases/titulos'
import DatePicker from '@/components/ui/DatePicker.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import type { Titulo, TipoDePessoa, Usuario, DetalhesPagamentoEmCheque, CentroDeCusto } from '@/models'
import {
	Cliente,
	FluxoDoTitulo,
	FormaDePagamento,
	FormDeTitulo,
	Fornecedor,
	Loja,
	Parcelamento,
	SituacaoDoTitulo,
	TipoDePagamento,		
} from '@/models'
import { maiorOuIgualAZero, obrigatorio } from '@/shareds/regras-de-form'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import SeletorDePessoa from '@/components/cliente/SeletorDePessoa.vue'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import { criarTitulo } from '@/shareds/titulo'
import { ClienteServiceAdapter, FindBaixaDePagamentoUseCase } from '@/usecases'
import type { DetalhesPagamentoEmChequeServiceAdapter } from '@/usecases'
import { BaixaDePagamento, BaixaDePagamentoAuditada } from '@/models/financeiro/BaixaDePagamento'
import axios, { CancelTokenSource } from 'axios'
import { DataOptions } from 'vuetify'
import { dateTimeToPtBrFormat, dateToPtBrFormat } from '@/shareds/date/date-utils'
import DialogoDeEdicaoDeBaixasDePagamento from './DialogoDeEdicaoDeBaixasDePagamento.vue'
import { DeleteBaixaDePagamentoUseCase } from '@/usecases/baixaDePagamento/DeleteBaixaDePagamentoUseCase'
import { formatarCnpjOuCpf, formatarMoeda } from '@/shareds/formatadores'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import { imprimirComprovanteDeRecebivel } from '@/shareds/venda-shareds'
import SeletorDeFornecedor from '@/components/fornecedor/SeletorDeFornecedor.vue'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue'
import { extrairCnpjOuCpfDaPessoa } from '@/shareds/cliente-shareds'
import SeletorDeFornecedorComBusca from '@/components/fornecedor/SeletorDeFornecedorComBusca.vue'
import { UpdateBaixaDePagamentoUseCase } from '@/usecases/baixaDePagamento/UpdateBaixaDePagamentoUseCase'
import RangerTimePicker from '@/components/ui/RangerTimePicker.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import DialogoDeEdicaoDeEstornoDePagamentosDosTitulos from './DialogoDeEdicaoDeEstornoDePagamentosDosTitulos.vue'
import { Inject } from 'inversify-props'
import { FindCentroDeCustoUseCase } from '@/usecases/titulos/FindCentroDeCustoUseCase'

type TipoDeAcao = 'edicao' | 'criacao';
type AbaDeTitulo<T extends TipoDeAcao> = T extends 'edicao'
  ? 'Principal' | 'Configuração Crediário'
  : 'Baixas';
@Component({
	components: {
		DatePicker,
		CampoDecimal,
		SeletorDePessoa,
		SeletorDeLojas,
		DialogoDeEdicaoDeBaixasDePagamento,
		Confirmacao,
		SeletorDeFornecedor,
		SeletorDeFornecedorComBusca,
		SeletorDeCliente,
		RangerTimePicker,
		DialogoDeEdicaoDeEstornoDePagamentosDosTitulos,
	},
})
export default class DialogoDeEdicaoDeTitulo extends Vue {
	@Prop() tipoDePessoa!: TipoDePessoa
	@Prop({ type: Boolean, default: false }) retornoCrediario!: boolean
	@Ref() form!: HTMLFormElement
	@Ref() campoDeLoja!: HTMLInputElement
	@Ref() dialogoDeBaixas!: DialogoDeEdicaoDeBaixasDePagamento
	@Ref() dialogoDeEstorno!: DialogoDeEdicaoDeEstornoDePagamentosDosTitulos
	@Ref() confirmacaoDeDeletarBaixa!: Confirmacao
	formulario: FormDeTitulo = criarTitulo('Entrada')
	@Prop() titulo!: Titulo
	@Ref() menu!: {
		save: (value?: any) => void
	}

	obrigatorio = obrigatorio
	formatarMoeda = formatarMoeda
	maiorOuIgualAZero = maiorOuIgualAZero

	condicao: string | null = null

	opcoesDeSituacaoDeTitulo: SituacaoDoTitulo[] = [
		'Aberto',
		'Cancelado',
		'Estornado',
		'Pago',
	]

	opcoesDeFormaDePagamento: FormaDePagamento[] = [
		'Cartão',
		'Dinheiro',
		'Voucher',
		'Crediário',
		'TEF Crédito',
		'TEF Débito',
		'TEF Pix',
		'Link',
		'Outros',
		'Cheque',
		'Boleto',
		'Pix',
	]

	opcoesDeFormaDePagamentoDaBaixa: FormaDePagamento[] = [
		'Dinheiro',
		'Cartão',
		'Pix',
		'Cheque',
		'Permuta',
	]

	buscando = false
	mostra = false
	show = false

	edicaoFormaPagamento = true
	editandoTitulo = true
	isParcelamento = false
	mostraMenuHoras = false
	modo = 'baixa'
	selecionado: BaixaDePagamento | null = null

	saveTituloUseCase = new SaveTituloUseCase()
	findBaixaDePagamento = new FindBaixaDePagamentoUseCase()
	cancelToken: CancelTokenSource | null = null
	deleteBaixasUseCase = new DeleteBaixaDePagamentoUseCase()
	updateBaixaUseCase = new UpdateBaixaDePagamentoUseCase()
	findTituloUseCase = new FindTituloUseCase()
	@Inject('DetalhesPagamentoEmChequeServiceAdapter')
	private detalhesPagamentoEmChequeService!: DetalhesPagamentoEmChequeServiceAdapter
	findCentroDeCustoUseCase = new FindCentroDeCustoUseCase()

	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	titulos: Titulo[] = []
	baixasDePagamento: BaixaDePagamentoAuditada[] = []
	tab: null | number = null
	tabs: AbaDeTitulo<TipoDeAcao>[] = []
	tituloParaBaixa: Titulo | null = null
	opcoesDeTiposDePagameto: TipoDePagamento[] | null = null
	cliente: Cliente | string | null = null
	private clienteService!: ClienteServiceAdapter
	disabled = false
	fornecedorCadastrado = false
	horas = ''
	data = ''
	detalhesPagamentoEmCheque: DetalhesPagamentoEmCheque | null = null
	tipoDeAcao: TipoDeAcao[] = []
	tipoDeDesconto: 'valorFixo' | 'porcentagem' = 'valorFixo'
	centrosDeCustoDaLoja: CentroDeCusto[] = []

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	parcelamento: Parcelamento = {
		quantidade: 2,
		recorrencia: 30,
		diaDoVencimento: null,
	}

	headers = [
		{ text: 'Forma de Pagamento', value: 'formaDePagamento' },
		{ text: 'Data do Movimento', value: 'dataDoMovimentoFormatada', sortable: false },
		{ text: 'Data da Baixa', value: 'dataHoraPagamentoFormatada', sortable: false },
		{ text: 'Total Pago', value: 'valorTotalPago' }, 
		{ text: 'Total Desconto', value: 'valorTotalDesconto' },
		{ text: 'Usuario Lançamento', value: 'usuarioRecebimento.nome' },
		{ text: 'Taxa', value: 'isTaxa' },
		{ text: 'Operador', value: 'nomeDoOperador' },
		{ text: 'Ações', value: 'actions', sortable: false },
	]

	headersSemActions = [
		{ text: 'Transação', value: 'transactionId' },
		{ text: 'Valor Pago', value: 'valorPagamento' },
		{ text: 'Usuario Lançamento', value: 'usuarioRecebimento.nome' },
		{ text: 'Operador', value: 'nomeDoOperador' },
		{ text: 'Taxa', value: 'isTaxa' },
	]

	get permitirAlterarDataBaixa() {
		return UserLoginStore.permiteRegraDeNegocio('permitir-alteracao-data-pagamento')
	}

	get titulosFormatados() {
		return this.titulos.map(titulo => ({
			...titulo,
			formaDePagamento: titulo.formaDePagamento ? titulo.formaDePagamento : '',
		}))
	}

	get baixasDePagamentoFormatados() {
		return this.baixasDePagamento
			.filter(baixa => baixa.tipoDeTransacao === 'Baixa' || baixa.tipoDeTransacao === null)
			.map(baixa => ({
				...baixa,
				id: baixa.id,
				transactionId: baixa.transactionId,
				valorPagamento: baixa.valorPagamento,
				dataHoraPagamentoFormatada: dateTimeToPtBrFormat(baixa.dataHoraPagamento),
				isTaxa: baixa.isTaxa,
				isIntegracao: baixa.isIntegracao,
				fechamentoDeCaixaAuditado: baixa.fechamentoDeCaixaAuditado,
				editandoFormaDePagamento: false,
				editandoDataDoPagamento: false,
				dataDoMovimentoFormatada: dateToPtBrFormat(baixa.created_at),
				nomeDoOperador: baixa.usuarioRecebimento ? baixa.usuarioRecebimento.nome : '--',
				estornado: baixa.estornado,
				tipoDeTransacao: baixa.tipoDeTransacao,
				valorJurosSobreBaixa: baixa.valorJurosSobreBaixa,
				valorDaMultaSobreBaixa: baixa.valorDaMultaSobreBaixa,
				valorTotalPago:
					'R$' + formatarMoeda(Number((baixa.valorPagamento || 0) +
					(baixa.valorJurosSobreBaixa || 0) +
					(baixa.valorDaMultaSobreBaixa || 0))),
				valorTotalDesconto: this.calcularValorTotalDesconto(baixa),
			}))
	}

	get estornoDeBaixasDePagamentoFormatados() {
		return this.baixasDePagamento
			.filter(baixa => baixa.tipoDeTransacao === 'Estorno')
			.map(baixa => ({
				...baixa,
				id: baixa.id,
				transactionId: baixa.transactionId,
				valorPagamento: baixa.valorPagamento,
				dataHoraPagamentoFormatada: dateTimeToPtBrFormat(baixa.dataHoraPagamento),
				isTaxa: baixa.isTaxa,
				isIntegracao: baixa.isIntegracao,
				fechamentoDeCaixaAuditado: baixa.fechamentoDeCaixaAuditado,
				editandoFormaDePagamento: false,
				editandoDataDoPagamento: false,
				dataDoMovimentoFormatada: dateToPtBrFormat(baixa.dataHoraPagamento),
				nomeDoOperador: baixa.usuarioRecebimento ? baixa.usuarioRecebimento.nome : '--',
				estornado: baixa.estornado,
				tipoDeTransacao: baixa.tipoDeTransacao,
				valorJurosSobreBaixa: baixa.valorJurosSobreBaixa,
				valorDaMultaSobreBaixa: baixa.valorDaMultaSobreBaixa,
				valorTotalPago:
					'R$' + formatarMoeda(Number(baixa.valorPagamento || 0) +
					(baixa.valorJurosSobreBaixa || 0) +
					(baixa.valorDaMultaSobreBaixa || 0)),
				valorTotalDesconto: this.calcularValorTotalDesconto(baixa),
			}))
	}

	@Watch('formulario.formaDePagamento')
	get abasPermitidas() {
		if((this.formulario.formaDePagamento === 'Crediário' || this.formulario.formaDePagamento === 'Crediario' || this.formulario.formaDePagamento === 'Boleto') && this.tipoDeAcao[0] === 'edicao'  && this.formulario.fluxo !== 'Saída'){
			this.tabs = ['Principal', 'Configuração Crediário', 'Baixas'];
		} else if(((this.formulario.formaDePagamento === 'Crediario' || this.formulario.formaDePagamento === 'Boleto') && this.tipoDeAcao[0] === 'criacao') || (this.formulario.formaDePagamento !== 'Crediario' && this.formulario.formaDePagamento !== 'Boleto' && this.tipoDeAcao[0] === 'criacao')) {
			this.tabs = ['Baixas'];
		} else if(this.formulario.formaDePagamento !== 'Crediario' && this.formulario.formaDePagamento !== 'Boleto' && this.tipoDeAcao[0] === 'edicao'){
			this.tabs = ['Principal'];
		} else if((this.formulario.formaDePagamento === 'Crediario' || this.formulario.formaDePagamento === 'Boleto') && this.tipoDeAcao[0] === 'edicao'  && this.formulario.fluxo === 'Saída'){
			this.tabs = ['Principal', 'Configuração Crediário'];
		} else if(this.formulario.fluxo === 'Saída' && this.tipoDeAcao[0] === 'edicao'){
			this.tabs = ['Principal']
		} else if(this.formulario.fluxo === 'Saída' && this.tipoDeAcao[0] === 'criacao'){
			this.tabs = ['Baixas'];
		}

		return this.tabs;
	}


	async imprimirComprovante(baixa: BaixaDePagamento) {
		try {
			const usuarioRecebimento = baixa.usuarioRecebimento as unknown as Usuario
			
			const baixaFormatada: BaixaDePagamento = {
				id: baixa.id,
				titulo: baixa.titulo,
				transactionId: baixa.transactionId,
				valorPagamento: baixa.valorPagamento,
				dataHoraPagamento: baixa.dataHoraPagamento,
				isTaxa: baixa.isTaxa,
				isIntegracao: baixa.isIntegracao,
				tipoDeTransacao: baixa.tipoDeTransacao,
				estornado: baixa.estornado,
				usuarioRecebimento: usuarioRecebimento ? usuarioRecebimento.id : '',
				valorJurosSobreBaixa: baixa.valorJurosSobreBaixa,
				valorDaMultaSobreBaixa: baixa.valorDaMultaSobreBaixa,
				valorDeDescontoNosJuros: 0,
				valorDeDescontoNaMulta: 0,
				tipoDeDesconto: this.tipoDeDesconto,
			}

			const pdf = await this.findBaixaDePagamento.imprimirBaixaDePagamento(baixaFormatada)
			await imprimirComprovanteDeRecebivel(pdf)
		} catch(error) {
			AlertModule.setError(error)
		}

	}

	async updateBaixaPagamento(baixa: BaixaDePagamentoAuditada) {
		if(!baixa) return

		const dataHora = `${this.data}T${this.horas}`
		const baixaDePagamento: BaixaDePagamento = {
			...baixa,
			dataHoraPagamento: dataHora,
			usuarioRecebimento: baixa.usuarioRecebimento.id,
		}

		try {
			await this.updateBaixaUseCase.updateBaixaDePagamento(baixaDePagamento)
			baixa.editandoDataDoPagamento = false
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.buscarBaixas()
		}
	}

	esconder(){
		this.baixasDePagamento = []
		this.mostra = false
		this.modo = 'baixa'
	}

	atualizaBaixas(baixa: BaixaDePagamento) {
		this.buscarBaixas()
		this.$emit('atualizar')
		this.$emit('valor', baixa)
		this.limparDados()
		this.mostra = false
	}

	exibeConfirmacao(item: BaixaDePagamento | null) {
		if(!item) return
		this.selecionado = JSON.parse(JSON.stringify(item))
		this.confirmacaoDeDeletarBaixa.mostrar()
		
	}

	async buscarBaixas() {
		if (this.cancelToken) this.cancelToken.cancel()

		try {
			this.buscando = true
			this.cancelToken = axios.CancelToken.source()
			const params = {
				tituloId: this.formulario.id,
				page: this.paginacao.page,
				size: this.paginacao.itemsPerPage,
			}

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			const page = await this.findBaixaDePagamento.findByTituloId(
				params,
				axiosConfig,
			)
			this.baixasDePagamento = page.content
			this.paginacao.itemsPerPage = 5

			this.buscando = false
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
			this.buscando = false
		}
	}

	mostrarDialogo(titulo: Titulo | FluxoDoTitulo, condicao: string, tipoDeAcao: TipoDeAcao) {
		this.limparDados()
		this.edicaoFormaPagamento = condicao == 'criar' ? false : true
		this.editandoTitulo = condicao == 'editar'
		this.mostra = true
		this.modo = 'baixa'
		this.tipoDeAcao = [tipoDeAcao]
		if (typeof titulo !== 'string') {
			this.tituloParaBaixa = titulo as Titulo
		}

		this.formulario =
			typeof titulo === 'string'
				? criarTitulo(titulo)
				: {
					...titulo,
					formaDePagamento: titulo.formaDePagamento
						? this.displayPagamento(titulo.formaDePagamento)
						: '',
					id: titulo.id ? titulo.id : '',
					tipoDePagamento: titulo.tipoDePagamento,
				}
		setTimeout(() => {
			this.campoDeLoja.focus()
		}, 250)
		if(this.edicaoFormaPagamento == true) this.buscarBaixas()

		!this.formulario.pessoa ? this.fornecedorCadastrado = false : this.fornecedorCadastrado = true
	}

	changeEditandoDataDoPagamento(item: BaixaDePagamentoAuditada) {
		const idx = this.baixasDePagamentoFormatados.findIndex(baixa => baixa.id === item.id)
		this.baixasDePagamentoFormatados[idx].editandoDataDoPagamento = !item.editandoDataDoPagamento

		if (item.dataHoraPagamento) {
			const [data, horaComMs] = item.dataHoraPagamento.split('T')
			const horas = horaComMs.split('.')[0]
			this.data = data
			this.horas = horas
		}
	}

	displayPagamento(formaDePagamento: string) {
		let formaFormatada
		if (formaDePagamento == 'CARTAO') formaFormatada = 'Cartão'
		if (formaDePagamento == 'DINHEIRO') formaFormatada = 'Dinheiro'
		if (formaDePagamento == 'VOUCHER') formaFormatada = 'Voucher'
		if (formaDePagamento == 'OUTROS') formaFormatada = 'Outros'
		if (formaDePagamento == 'TEF CREDITO') formaFormatada = 'TEF Crédito'
		if (formaDePagamento == 'TEF DEBITO') formaFormatada = 'TEF Débito'
		if (formaDePagamento == 'CREDIARIO') formaFormatada = 'Crediario'
		if (formaDePagamento == 'CHEQUE') formaFormatada = 'Cheque'
		if (formaDePagamento == 'BOLETO') formaFormatada = 'Boleto'
		if (formaDePagamento == 'PIX') formaFormatada = 'Pix'
		return formaFormatada
	}

	get valorFaltante() {		
		if (this.tituloParaBaixa && this.baixasDePagamento && this.tituloParaBaixa.id) {
			return this.tituloParaBaixa.valorAtualizado
		}
		return 0
	}

	abrirDialogoDeCriacaoDeBaixa() {
		const valorFaltante = this.valorFaltante ?? 0;
		this.dialogoDeBaixas.mostrarDialogo(this.tituloParaBaixa, valorFaltante, false);
	}

	abrirDialogoDeEdicaoDeBaixa(item: BaixaDePagamento) {
		const valorFaltante = this.valorFaltante ?? 0;
		this.dialogoDeBaixas.mostrarDialogo(this.tituloParaBaixa, valorFaltante, true, item);
	}

	abrirDialogoDeEstornoDeBaixa(){
		const valorValidoParaEstornos = this.baixasDePagamento.reduce((soma, baixa) => soma + baixa.valorPagamento, 0)

		const totalValorBaixa = this.baixasDePagamento.reduce((soma, baixa) => soma + (!baixa.isTaxa ? baixa.valorPagamento : 0), 0)
		const totalValorDesconto = this.baixasDePagamento.reduce((soma, baixa) => soma + (baixa.valorDesconto ?? 0), 0)
		const totalValorTaxa = this.baixasDePagamento.reduce((soma, baixa) => soma + (baixa.isTaxa ? baixa.valorPagamento : 0), 0)
		const valorJurosSobreBaixa = this.baixasDePagamento.reduce((soma, baixa) => soma + (baixa.valorJurosSobreBaixa ?? 0), 0)
		const valorDaMultaSobreBaixa = this.baixasDePagamento.reduce((soma, baixa) => soma + (baixa.valorDaMultaSobreBaixa ?? 0), 0)
		const valorDeDescontoSobreBaixa = this.baixasDePagamento.reduce((soma, baixa) => soma + (baixa.valorDesconto ?? 0), 0)
		const totalValorDescontoJuros = this.baixasDePagamento.reduce((soma, baixa) => soma + (baixa.valorDeDescontoNosJuros ?? 0), 0)
		const totalValorDescontoMulta = this.baixasDePagamento.reduce((soma, baixa) => soma + (baixa.valorDeDescontoNaMulta ?? 0), 0)

		if(valorValidoParaEstornos + valorDaMultaSobreBaixa + valorJurosSobreBaixa + valorDeDescontoSobreBaixa <= 0){
			AlertModule.setError('Sem valores de baixa para estornar!')
			return
		}

		const titulo: Titulo = {
			...this.formulario,
			id: this.formulario.id ?? '',
			numero: 0,
			sequencia: 0, 
			serie: null,
			situacao: {} as SituacaoDoTitulo,
			temParcelamento: false,
			tipoDePagamento: this.formulario.tipoDePagamento ?? {} as TipoDePagamento,
			valor: this.formulario.valor ? Number(this.formulario.valor) : 0,
			dataDeVencimento: this.formulario.dataDeVencimento ?? '',
			dataDeCompetencia: this.formulario.dataDeCompetencia ?? '',
		}
		
		this.dialogoDeEstorno.mostrarDialogo(valorValidoParaEstornos, titulo, totalValorBaixa, totalValorDesconto, totalValorTaxa, valorJurosSobreBaixa, valorDaMultaSobreBaixa, totalValorDescontoJuros, totalValorDescontoMulta)
	}

	async salvarTitulo() {
		try {
			this.disabled = true
			if (!this.form.validate()) return
			if (!this.formulario) return

			if (this.detalhesPagamentoEmCheque && this.formulario.tipoDePagamento?.formaDePagamento === 'Cheque'){
				await this.detalhesPagamentoEmChequeService.criarPagamentoEmCheque(this.detalhesPagamentoEmCheque)
			}
			
			const titulos = await this.saveTituloUseCase.execute(this.formulario, this.parcelamento)

			this.$emit('salvar', titulos)
			this.formulario = criarTitulo('Entrada')
			this.baixasDePagamento = []
			this.mostra = false
		} catch (e) {
			AlertModule.setError(e)
			this.disabled = false
		} finally{
			this.disabled = false
			this.modo = 'baixa'
		}
	}

	get itens() {
		return this.baixasDePagamento
	}

	async salvarFormaDePagamento(item: BaixaDePagamentoAuditada) {
	
		if(!item) return
		if(!item.formaDePagamento) return
		try {
			await this.updateBaixaUseCase.update(item.id, item.formaDePagamento)
			item.editandoFormaDePagamento = false;
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async removerBaixa(baixa: BaixaDePagamento | null) {
		if (!baixa) return

		try {
			await this.deleteBaixasUseCase.execute(baixa.id)
			this.baixasDePagamento = this.baixasDePagamento.filter(
				({ id }) => id !== baixa.id,
			)

			this.formulario.id = this.formulario.id ?? ''; 

			const titulo = await this.findTituloUseCase.findById(this.formulario.id);

			if (
				(titulo.formaDePagamento === 'CREDIARIO' || titulo.formaDePagamento === 'BOLETO') &&
				titulo.fluxo === 'Entrada'
			) {
				await this.saveTituloUseCase.calcularJurosDoTitulo(titulo.id)
			}

			this.formulario = {
				...titulo,
				formaDePagamento: titulo.formaDePagamento
					? this.displayPagamento(titulo.formaDePagamento)
					: '',
				id: titulo.id ? titulo.id : '',
				tipoDePagamento: titulo.tipoDePagamento,
			}
			this.$emit('aplicar')
			this.mostra = false
			this.modo = 'baixa'
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) return this.tituloParaBaixa = null
		window.requestAnimationFrame(() => {
			this.form.resetValidation()
		})
		this.modo = 'baixa'
	}
	
	@Watch('formulario.formaDePagamento')
	onChangeFormulario() {
		if (this.formulario.formaDePagamento == 'Dinheiro') return this.formulario.temParcelamento = false
	}

	@Watch('formulario.loja', { immediate: true, deep: true })
	async onChangeLoja(lojaAtual: Loja | null, lojaAnterior: Loja | null) {
		if (lojaAtual && lojaAnterior !== lojaAtual) {
			this.opcoesDeTiposDePagameto = lojaAtual.tiposDePagamento
			this.centrosDeCustoDaLoja = await this.findCentroDeCustoUseCase.findCentroDeCustoByLojaId({lojaId: lojaAtual.id})
		}
	}

	@Watch('formulario.tipoDePagamento')
	onChangeTipoDePagamento(tipoDePagamentoAtual: TipoDePagamento | null, tipoDePagamentoAnterior: TipoDePagamento | null) {
		if (!tipoDePagamentoAtual && tipoDePagamentoAtual !== tipoDePagamentoAnterior) {
			this.formulario.formaDePagamento = null
		}

		if (tipoDePagamentoAtual && tipoDePagamentoAtual !== tipoDePagamentoAnterior) {
			this.formulario.formaDePagamento = tipoDePagamentoAtual.formaDePagamento
		}
	}
	
	@Watch('formulario.temParcelamento')
	onChangeTemParcelamento() {
		this.show = !this.show
	}

	async fornecedorSelecionadoitem(item: Fornecedor | string) {
		this.cliente = typeof item === 'string' ? await this.getFornecedor(item): await this.getFornecedor(item.cnpjOuCpf) 
	}

	async getFornecedor(cpfOuCnpj: string | null) {
		if (cpfOuCnpj) {
			try {
				return await this.clienteService.get(cpfOuCnpj);
			} catch(err) {
				return cpfOuCnpj
			}
		}
		return cpfOuCnpj
	}

	validateDiaDoVencimento() {
		if (this.parcelamento.diaDoVencimento == null) return 
		
		if (this.parcelamento.diaDoVencimento > 31) {
			this.parcelamento.diaDoVencimento = 31;
		}
	}

	calcularValorTotalDesconto(baixa: BaixaDePagamentoAuditada): string {
		const valorDesconto = baixa.valorDesconto || 0
		const valorDescontoNosJuros = baixa.valorDeDescontoNosJuros || 0
		const valorDescontoNaMulta = baixa.valorDeDescontoNaMulta || 0
		const totalDesconto = valorDesconto + valorDescontoNosJuros + valorDescontoNaMulta
		
		return 'R$' + formatarMoeda(Number(totalDesconto.toFixed(2)))
	}
	
	get cnpjOuCpfFormatado() {
		const cnpjOuCpf = extrairCnpjOuCpfDaPessoa(this.formulario.pessoa)
		return cnpjOuCpf ? formatarCnpjOuCpf(cnpjOuCpf) : ''
	}

	limparDados() {
		this.titulos = []
		this.baixasDePagamento = []
		this.tab = 0
		this.tabs = []
		this.tituloParaBaixa = null
		this.opcoesDeTiposDePagameto = null
		this.cliente = null
		this.horas = ''
		this.data = ''

	}

	get temRecurso() {
		return UserLoginStore.temAutorizacaoPorOperacaoERecurso
	}

	irParaVendaOrigem(IdentificadorDaVenda: string | null){
		if (this.temRecurso('ler', 'vendas')) {
			window.open(`/vendas?identificador=${IdentificadorDaVenda}`, '_blank')
		}
	}
  
	get podeExcluirBaixasDePagamento(){
		return UserLoginStore.permiteRegraDeNegocio('pode-excluir-baixas-de-contas-a-receber')
	}

	async abrirDetalhesDoPagamentoEmCheque() {
		if (!this.formulario) return

		try {
			this.show = !this.show
			if (this.show){
				if (this.formulario.id){
					this.detalhesPagamentoEmCheque = await this.detalhesPagamentoEmChequeService.findByTituloId(this.formulario.id)
				} else {
					this.detalhesPagamentoEmCheque = {
						id: '',
						dataVencimento: null,
						banco: '',
						agencia: '',
						conta: '',
						numeroDoCheque: '',
						identificadorDaVenda: '',
					}
				}
			}
		}
		catch (error: any){
			AlertModule.setError(error)
		}
		
	}
	
	get podeAlterarDatasDeVencimentoECompetencia() {
		return UserLoginStore.permiteRegraDeNegocio('pode-alterar-data-de-vencimento-e-competencia')
	}

}
